/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var CardBox, PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

CardBox = require('./card-box');

css = require('../css/game-list.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'GameList',
  createNewGame: function() {
    var name, ref;
    name = (ref = prompt('Název hry')) != null ? ref.trim() : void 0;
    if (!(name && name.length > 2)) {
      return;
    }
    return this.props.actions.createNewGame(name);
  },
  joinGame: function(gameId) {
    return this.props.actions.joinGame(gameId);
  },
  render: function() {
    var items;
    items = [
      React.createElement(CardBox, {
        "key": 'NEW GAME',
        "type": 'black',
        "didClick": this.createNewGame,
        "customClassNames": [css['game']]
      }, "\t\t\t\tNová hra")
    ];
    items = items.concat(Object.keys(this.props.games.items).map((function(_this) {
      return function(gameId, i) {
        var game, players;
        game = _this.props.games.items[gameId];
        players = game.players.map(function(player) {
          return player.nickname;
        });
        return React.createElement(CardBox, {
          "key": game.id,
          "id": game.id,
          "type": 'white',
          "didClick": _this.joinGame,
          "customClassNames": [css['game']]
        }, game.name, React.createElement("div", {
          "className": css['player-names']
        }, React.createElement("div", null, React.createElement("strong", null, "Players: ")), players.join(', ')));
      };
    })(this)));
    return React.createElement("div", {
      "className": css['game-list']
    }, items);
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "game-list.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/game-list.cjsx
 ** module id = 254
 ** module chunks = 0
 **/